module.exports = __webpack_public_path__ + "static/media/UpgradeTeam.30f028cc.png";